import React, { useState } from 'react';

import '../../../static/css/main.css'
import '../../../static/css/animate.css'
import '../../../static/fonts/stylesheet.css'
import { useDispatch, useSelector } from 'react-redux';
import { selectIdBank, selectTypeObject, setIdBank } from '../../calc/calcSlice';
import { list_banks } from '../../../static/vars';




export function DropDownBank(props) {
    const dispatch = useDispatch()

    const idBank = useSelector(selectIdBank)

    const [showDropDown, setShowDropDown] = useState(false);

    const handleClickDropDown = () => {
        setShowDropDown(!showDropDown)
    }

    function handleClickBank(value) {
        props.setIsChangeParams(true)
        dispatch(setIdBank(value))
        setShowDropDown(false)
    }

    return (
        <div class="form-1-col form-1-col-1">
            <div class="form-group">
                <div class="dropdown hint4">
                    <label for="select-1">Банк кредитор</label>
                    <button onClick={handleClickDropDown} class="dropdown__button">{list_banks.find(x => x.value === idBank).label}</button>
                    {showDropDown &&
                        <ul class="dropdown__list_prc">
                            {
                                list_banks.map((bank, index) => {
                                    return (
                                        <li key={index} 
                                            class="dropdown__list-item"
                                            onClick={() => {
                                                handleClickBank(bank.value)
                                                window.ym(90426649,'reachGoal',bank.ym)
                                            }}
                                        >
                                            {bank.label}
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    }
                    <input type="text" name="select-category" value=""
                        class="dropdown__input-hidden" />
                </div>
            </div>
        </div>
    );
}



